import React from "react";
import HeroImage from "../assets/heroImage.png";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import Spline from '@splinetool/react-spline';
const Home = () => {
  return (
    <div
      name="home"
      className="md:h-screen h-auto w-full bg-gradient-to-b from-black via-black to-gray-800 pb-20 md:pb-0"
    >
      
      <div className="relative top-32 md:top-16  flex flex-col items-center justify-center h-full px-4 md:flex-row  overflow-scroll md:overflow-hidden">
        <div className="w-full md:relative md:mr-auto md:ml-20 ml-8 md:w-1/2 flex flex-col justify-center h-full">
          
          <p className="text-gray-500 py-4 max-w-md p-2">
         
          Hi! This is Muhammad Arshad
          </p>
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
          I'm a Full Stack Developer
          </h2>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>

        {/* <div>
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-2xl mx-auto w-2/3 md:w-full"
          />
        </div> */}
         <div className="w-screen  md:absolute  md:w-1/2 md:right-0 md:h-full h-screen z-10">
      <Spline className=" " scene="https://prod.spline.design/QnbG1jlo7X1fUndD/scene.splinecode" />
      </div>
      </div>
     
    </div>
  );
};

export default Home;
